<template>
  <div
    class="set-option-item"
  >
    <a-form-item class="item-move-icon">
      <i
        class="icon iconfont iconicon-test72"
      />
    </a-form-item>
    <a-form-item
      :class="{'radio-type-tit': itemData.fieldtype === 'radioinfo_type'}"
    >
      <a-input
        v-decorator="decorator"
        :disabled="!!item.issystem"
        :placeholder="itemData.fieldtype === 'radioinfo_type'? infoClassPlace : enterPlaceholder"
        @change="changeVal"
      />
    </a-form-item>
    <a-form-item
      v-if="itemData.fieldtype === 'radioinfo_type'"
      :class="{'radio-type-con': itemData.fieldtype === 'radioinfo_type'}"
    >
      <a-input
        v-decorator="decoratorinfo"
        :disabled="item.name===keepRecord"
        :placeholder="infoClassPlace"
        @change="changeTypeInfo"
      />
    </a-form-item>
    <a-form-item
      v-if="isCanDefault && (itemData.fieldtype === 'radioinfo_type' || itemData.fieldtype === 'select' || itemData.fieldtype === 'radio')"
    >
      <a-select
        v-decorator="decorator2"
        @change="getSlectVal"
      >
        <a-select-option value="0">
          <a-tooltip
            v-if="isEnglish"
            overlay-class-name="form-label-tooltip"
            trigger="hover"
          >
            <span
              slot="title"
            >
              {{ $t('message["1088"]') }}
            </span>
            {{ $t('message["1088"]') }}
          </a-tooltip>
          <template v-else>
            {{ $t('message["1088"]') }}
          </template>
        </a-select-option>
        <a-select-option value="1">
          <a-tooltip
            v-if="isEnglish"
            overlay-class-name="form-label-tooltip"
            trigger="hover"
          >
            <span
              slot="title"
            >
              {{ $t('message["529"]') }}
            </span>
            {{ $t('message["529"]') }}
          </a-tooltip>
          <template v-else>
            {{ $t('message["529"]') }}
          </template>
        </a-select-option>
        <a-select-option value="2">
          <a-tooltip
            v-if="isEnglish"
            overlay-class-name="form-label-tooltip"
            trigger="hover"
          >
            <span
              slot="title"
            >
              {{ $t('message["527"]') }}
            </span>
            {{ $t('message["527"]') }}
          </a-tooltip>
          <template v-else>
            {{ $t('message["527"]') }}
          </template>
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item
      v-if="itemData.fieldtype === 'radioinfo_followup'"
      class="mr0"
    >
      <a-checkbox
        :default-checked="!!item.isend"
        @change="checkboxChange"
      >
        {{ $t('message["513"]') }}
      </a-checkbox>
    </a-form-item>
    <a-form-item
      v-if="itemData.fieldtype === 'radioinfo_type'"
      class="mr0"
    >
      <a-checkbox
        :default-checked="!!item.isend"
        @change="checkboxChange"
      >
        {{ $t('message["511"]') }}
      </a-checkbox>
    </a-form-item>
    <a-form-item
      v-if="itemData.fieldtype !== 'checkbox' && isCanDefault &&(item.visibletype * 1 !== 2)"
      class="mr0"
    >
      <a-checkbox
        class="radio-item-check"
        :checked="!!item.isdefault"
        @change="radioChange"
      >
        <!-- {{ $t('message["511"]') }} -->
        {{ isDefaultTxt }}
      </a-checkbox>
    </a-form-item>
    <a-form-item class="mr0">
      <i
        v-if="!item.issystem"
        class="icon iconfont iconicon-test8"
        @click="delDefine(item,index)"
      />
    </a-form-item>
  </div>
</template>
<script>
import { getLang } from '@/lib/storage'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isCanDefault: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      decorator: [
        `input_${this.item.id || this.item._id}`,
        {
          rules: [{ required: true, message: this.$t('message["67"]') }, { validator: this.isNameRe }],
          initialValue: this.item.name
        }
      ],
      decoratorinfo: [
        `input_${this.item.id || this.item._id}_con`,
        {
          // rules: [{ required: true, message: '不能为空' }, { validator: this.isNameRe }],
          initialValue: this.item.typeshow
        }
      ],
      decorator2: [
        `visibletype_${this.item.id || this.item._id}`,
        {
          rules: [{ required: true, message: this.$t('message["67"]') }],
          initialValue: this.item.visibletype ? (this.item.visibletype + '') : '0'
        }
      ]
    }
  },
  computed: {
    keepRecord () {
      return this.$t('message["26"]')
    },
    infoClassPlace () {
      return this.$t('message["821"]')
    },
    enterPlaceholder () {
      return this.$t('message["754"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    isDefaultTxt () {
      const { isdefault = 0 } = this.item
      return isdefault ? this.$t('message[1780]') : this.$t('message[1779]')
    }
  },
  inject: ['diaform'],
  methods: {
    getLang,
    delDefine (item, index) {
      // const { form } = this
      // const inputDatas = form.getFieldValue('name')
      // inputDatas.splice(index, 1)
      // form.setFieldsValue({
      //   name: inputDatas
      // })
      this.itemData.options.splice(index, 1)
      this.$set(this.itemData, 'options', this.itemData.options)
    },
    changeVal (e) {
      const val = (e.target.value).trim()
      this.item.name = val
      this.$nextTick(() => {
        this.diaform.form.setFieldsValue({
          [`input_${this.item.id || this.item._id}`]: val
        })
        // this.diaform.form.validateFields([`input_${this.item.id || this.item._id}`])
        this.diaform.form.validateFields({ force: true }, (errors, values) => {})
      })
    },
    changeTypeInfo (e) {
      // this.item.typeshow = e.target.value
      const val = (e.target.value).trim()
      this.item.typeshow = val
      this.$nextTick(() => {
        this.diaform.form.setFieldsValue({
          [`input_${this.item.id || this.item._id}_con`]: val
        })
        // this.diaform.form.validateFields([`input_${this.item.id || this.item._id}_con`])
        this.diaform.form.validateFields({ force: true }, (errors, values) => {})
      })
    },
    checkboxChange (e) {
      if (e.target.checked) {
        this.item.isend = 1
      } else {
        this.item.isend = 0
      }
    },
    radioChange (e) {
      if (e.target.checked) {
        this.itemData.options.forEach(item => {
          this.$set(item, 'isdefault', 0)
        })
        this.item.isdefault = 1
      } else {
        this.item.isdefault = 0
      }
    },
    getSlectVal (val) {
      this.item.visibletype = val * 1
    },
    isNameRe (rule, value, callback) {
      const arr = this.itemData.options
      const len = arr.filter((item, index) => item.name === value).length
      if (len > 1) {
        callback(new Error(this.$t('message["69"]')))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .set-option-item::v-deep {
    cursor: pointer;
    display: block;
    height: 36px;
    padding: 8px 8px 4px 32px;
    line-height: 36px;
    box-sizing: content-box;
    position: relative;
    .radio-item-check {
      .ant-checkbox-inner{
        border-radius: 50%;
      }
      .ant-checkbox-input{
        border-radius: 50%;
      }
    }
    .iconicon-test72 {
      font-size: 16px;
      cursor: move;
      color: #ccc;
      display: none;
    }
    .item-move-icon {
      position: absolute;
      left: 8px;
    }
    .iconicon-test8 {
      color: #ccc;
      display: none;
      cursor: pointer;
    }
    .ant-select {
      width: 130px;
    }
    .ant-checkbox-wrapper {
      margin-right: 16px;
    }
    .mr0 {
      margin-right: 0 !important;
    }
    // .ant-form-item {
    //   margin-right: 0;
    // }
    .radio-type-tit .ant-input{
      width: 120px;
    }
    .radio-type-con .ant-input {
      width: 290px;
    }
  }
.set-option-item:hover {
    background: #f4f7f9;
    .iconicon-test72, .iconicon-test8 {
      display: inline-block;
    }
  }
</style>
